// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"151":"de40e405","585":"ac410e72"}[chunkId] + ".chunk.js";
};